module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-8"
    }
  }, [_c('span', {
    staticClass: "ct "
  }, [_c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_vm._v("A")])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_vm._v("lchemy")])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_c('p', {
    staticClass: "txnoi"
  }, [_vm._v("Some scholars say the name "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("alchemy")]), _vm._v(" comes from the Greek "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("cheo")]), _vm._v(", meaning “I pour” or “I cast,” since much of alchemy has to do with the working of metals. But many believe the word comes from the Egyptian "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Khem,")]), _vm._v(" meaning “the black land” (land with black earth), and see that as indicating Egypt as alchemy’s place of origin. The Arabic article "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("al")]), _vm._v(" was added to "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Khem")]), _vm._v(" to give "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("alchemy")]), _vm._v(". Later, as the science (some call it a pseudoscience) progressed, the article was again dropped, to become "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("chemistry")]), _vm._v(". Alchemy certainly is the early history of chemistry. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was an early Egyptian alchemist whose name was Chemes. He wrote a book, called "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Chema")]), _vm._v(", about his experiments trying to turn base metal into gold. Some few believe that the word alchemist comes from his name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Whatever the origin of the word, it seems certain that the practice of alchemy had its beginnings in the Hellenistic culture of Alexandria, Egypt, which was the center of the world ")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("of learning at that time. In fact alchemy is a blending of Egyp")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("tian technology, Greek philosophy, and Middle Eastern ")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("mysticism. The first alchemists were the metallurgical workers who prepared precious metals for the nobles but also produced cheap substitutes for the less affluent. These cheaper substitutes were often disguised to look like the more precious metals. It didn’t take long for the idea to develop that it might be possible to actually produce the precious metals themselves. This idea, in fact, was backed by Aristotle’s theory that there was a prime matter that was the basis for all substances. Astrology added the concept that the greater outer world of planets and stars reflected the inner world of humankind: a macrocosm and a microcosm. It was believed that under the proper astrological influences, it should be possible to change one metal into another; for example, lead into gold. In the same way that humankind perfected, going through death and rebirth, so might metals perfect and grow from one base form to another higher form. ")]), _c('span', {
    staticClass: "char-style-override-2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Philosopher’s Stone")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v(" was the term given to a stone that—if it could be developed—would serve as the catalyst to transform metals and other raw material into gold. Although referred to as a stone, it was not necessarily an actual stone for it was believed that it might be a combination of fire and water, or other unlikely mixtures.")])])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("So the original alchemy became an operation of passing substances through a series of chemical processes. The actual workings were noted, but in symbolic form to protect them from the dabblers and the uninitiated, and also to protect the alchemists themselves from charges by the Church that they were involved in heresy. The metals were represented by the astrological sign of the controlling body, and frequently the components and the actions were assimilated with Greek and Roman myths and mythological beings. The more the individual alchemists tried to hide and protect the results of their experiments, the more obtuse and confusing became much of what they did and said. In describing necessary actions, they used language such as: “When we marry the crowned king with the red daughter, she will conceive a son in the gentle fire . . . the dragon shuns the light of the sun, and our dead son shall live. The king comes forth from the fire and rejoices in the marriage.”")]), _c('span', {
    staticClass: "fnref char-style-override-3"
  })]), _c('a', {
    staticClass: "footnote-link",
    attrs: {
      "href": "#/#footnote-237-1",
      "id": "footnote-237-1-backlink"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "char-style-override-2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Hermes Trismegistus, also known as “Thrice Great Hermes” (it is from his name that the term ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("the hermetic art")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v(" was given to alchemy), has been variously described as an earthly incarnation of the Egyptian god Thoth and as an Egyptian priest, or a pharaoh, who taught the Egyptians all their magic. He is credited with having written several thousand books, including the Emerald Tablet, or ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Tabula Smaragdina")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v(", which contained all the hermetic teachings—the thirteen precepts—including the fundamental principles for the ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Grand ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Arcanum")]), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v(", or “great secret.” There are many references to the Emerald Tablet in alchemical writings. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Instruments")]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "01-crucible.tif",
      "src": "image/01-crucible_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Crucible")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "02-dropper.tif",
      "src": "image/02-dropper_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dropper")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "03-grille.tif",
      "src": "image/03-grille_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Grille")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "04-receiver.tif",
      "src": "image/04-receiver_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', [_vm._v("Receiver ")])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Instruments "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "05-retort.tif",
      "src": "image/05-retort_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Retort")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "06-scull.tif",
      "src": "image/06-scull_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Scull")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "07-still.tif",
      "src": "image/07-still_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Still")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "08-wick.tif",
      "src": "image/08-wick_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Wick")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Weights and Measures")]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "09-1ounce.tif",
      "src": "image/09-1ounce_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Ounce")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "10-1dram.tif",
      "src": "image/10-1dram_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dram")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "11-1scruple.tif",
      "src": "image/11-1scruple_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Scruple")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "12-1pinch.tif",
      "src": "image/12-1pinch_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pinch")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Weights and Measures "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "13-1pint.tif",
      "src": "image/13-1pint_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pint")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "14-1pound.tif",
      "src": "image/14-1pound_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pound")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Spirits")]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "15-copper.tif",
      "src": "image/15-copper_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Copper")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "16-mercury.tif",
      "src": "image/16-mercury_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Mercury")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "17-silver.tif",
      "src": "image/17-silver_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Silver")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "18-tin.tif",
      "src": "image/18-tin_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Tin")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "19-worldofspirit.tif",
      "src": "image/19-worldofspirit_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption-center"
  }, [_vm._v("World of Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Seasons")]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "20-spring.tif",
      "src": "image/20-spring_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "21-summer.tif",
      "src": "image/21-summer_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "22-autumn.tif",
      "src": "image/22-autumn_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Autumn")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "23-winter.tif",
      "src": "image/23-winter_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Winter")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Materials")]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "24-gold.tif",
      "src": "image/24-gold_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gold (i)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "25-gold.tif",
      "src": "image/25-gold_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gold (ii)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "26-gold.tif",
      "src": "image/26-gold_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gold (iii)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "27-gold.tif",
      "src": "image/27-gold_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gold (iv)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Materials "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "28-gold.tif",
      "src": "image/28-gold_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gold (v)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "29-gold.tif",
      "src": "image/29-gold_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gold (vi)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "30-gold.tif",
      "src": "image/30-gold_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gold (vii)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "31-silver.tif",
      "src": "image/31-silver_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Silver (i)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "32-silver.tif",
      "src": "image/32-silver_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Silver (ii)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "33-silver.tif",
      "src": "image/33-silver_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Silver (iii)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "34-alum.tif",
      "src": "image/34-alum_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Alum")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "35-antimony.tif",
      "src": "image/35-antimony_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Antimony")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Materials "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "36-arsenic_sulfur.tif",
      "src": "image/36-arsenic_sulfur_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Arsenic-Sulfur ")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "37-aquavita.tif",
      "src": "image/37-aquavita_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Aqua Vitæ")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "38-bismuth.tif",
      "src": "image/38-bismuth_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Bismuth")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "39-borax.tif",
      "src": "image/39-borax_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Borax")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "40-brass.tif",
      "src": "image/40-brass_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Brass")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "41-burnedalum.tif",
      "src": "image/41-burnedalum_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Burned Alum")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "42-burnedhartshorn.tif",
      "src": "image/42-burnedhartshorn_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Burned Hartshorn")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "43-causticlime.tif",
      "src": "image/43-causticlime_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Caustic Lime")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Materials "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "44-chalc.tif",
      "src": "image/44-chalc_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Chalc")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "45-cinder.tif",
      "src": "image/45-cinder_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cinder")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "46-cinnibar.tif",
      "src": "image/46-cinnibar_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cinnibar")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "47-clay.tif",
      "src": "image/47-clay_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Clay")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "48-copper.tif",
      "src": "image/48-copper_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Copper")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "49-cribbedashes.tif",
      "src": "image/49-cribbedashes_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cribbled Ashes")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "50-crystal.tif",
      "src": "image/50-crystal_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Crystal")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "51-eggshells.tif",
      "src": "image/51-eggshells_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Eggshells")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Materials "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "52-ginger.tif",
      "src": "image/52-ginger_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Ginger")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "53-glass.tif",
      "src": "image/53-glass_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Glass")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "54-gravel.tif",
      "src": "image/54-gravel_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gravel")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "55-iron.tif",
      "src": "image/55-iron_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Iron")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "56-ironfillings.tif",
      "src": "image/56-ironfillings_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Iron Filings")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "57-lead.tif",
      "src": "image/57-lead_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lead")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "58-lime.tif",
      "src": "image/58-lime_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lime")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "59-magnesia.tif",
      "src": "image/59-magnesia_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Magnesia")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead para-style-override-1"
  }, [_vm._v("Materials "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "60-manure.tif",
      "src": "image/60-manure_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Manure")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "61-mercury.tif",
      "src": "image/61-mercury_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Mercury")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "62-nickel.tif",
      "src": "image/62-nickel_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Nickel")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "63-niterflowers.tif",
      "src": "image/63-niterflowers_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Niter Flowers ")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "64-niteroil.tif",
      "src": "image/64-niteroil_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Niter Oil")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "65-nitricacid.tif",
      "src": "image/65-nitricacid_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Nitric Acid")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "66-potash.tif",
      "src": "image/66-potash_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Potash")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "67-redarsenic.tif",
      "src": "image/67-redarsenic_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Red Arsenic")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead "
  }, [_vm._v("Materials "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "68-rocksalt.tif",
      "src": "image/68-rocksalt_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Rock Salt")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "69-seasalt.tif",
      "src": "image/69-seasalt_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sea Salt")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "70-soapstone.tif",
      "src": "image/70-soapstone_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Soapstone")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "71-soot.tif",
      "src": "image/71-soot_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Soot")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "72-steel.tif",
      "src": "image/72-steel_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Steel")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "73-stone.tif",
      "src": "image/73-stone_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Stone")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "74-sugar.tif",
      "src": "image/74-sugar_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sugar")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "75-sulfur.tif",
      "src": "image/75-sulfur_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sulfur")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Materials "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "76-tin.tif",
      "src": "image/76-tin_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Tin")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "77-urine.tif",
      "src": "image/77-urine_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Urine")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "78-verdigris.tif",
      "src": "image/78-verdigris_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Verdigris")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "79-vinegar.tif",
      "src": "image/79-vinegar_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Vinegar")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "80-vitriol.tif",
      "src": "image/80-vitriol_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Vitriol")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "81-whitearsenic.tif",
      "src": "image/81-whitearsenic_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("White Arsenic")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "82-winespirit.tif",
      "src": "image/82-winespirit_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Wine Spirit")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "83-wood.tif",
      "src": "image/83-wood_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Wood")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Materials "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "84-yellowarsenic.tif",
      "src": "image/84-yellowarsenic_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Yellow Arsenic")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "85-yellowwax.tif",
      "src": "image/85-yellowwax_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Yellow Wax")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "86-zinc.tif",
      "src": "image/86-zinc_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption-center"
  }, [_vm._v("Zinc")])]), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Processes")]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "87-blackening.tif",
      "src": "image/87-blackening_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Blackening (melanosis)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "88-whitening.tif",
      "src": "image/88-whitening_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Whitening (leucosis)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "89-yellowing.tif",
      "src": "image/89-yellowing_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Yellowing (xanthosis)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "90-reddening.tif",
      "src": "image/90-reddening_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Reddening (iosis)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Processes "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "91-amalgam.tif",
      "src": "image/91-amalgam_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Amalgam")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "92-amalgamation.tif",
      "src": "image/92-amalgamation_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Amalgamation")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "93-toboil.tif",
      "src": "image/93-toboil_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Boil")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "94-tocompose.tif",
      "src": "image/94-tocompose_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Compose")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "95-distill.tif",
      "src": "image/95-distill_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Distill")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "96-essence.tif",
      "src": "image/96-essence_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Essence")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "97-fumes.tif",
      "src": "image/97-fumes_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fumes")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "98-filter.tif",
      "src": "image/98-filter_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Filter")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Processes "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "99-tomix.tif",
      "src": "image/99-tomix_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Mix")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "100-topowder.tif",
      "src": "image/100-topowder_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Powder")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "101-topurify.tif",
      "src": "image/101-topurify_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Purify")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "102-topulverize.tif",
      "src": "image/102-topulverize_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pulverize")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "103-torot.tif",
      "src": "image/103-torot_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Rot")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "104-tosolve.tif",
      "src": "image/104-tosolve_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Solve")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "105-sublime.tif",
      "src": "image/105-sublime_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sublime")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "106-take.tif",
      "src": "image/106-take_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Take")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Processes "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "107-torrefactiongold.tif",
      "src": "image/107-torrefactiongold_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Torrefaction of Gold ")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "108-torrefactionsilver.tif",
      "src": "image/108-torrefactionsilver_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Torrefaction of Silver")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead para-style-override-1"
  }, [_vm._v("Animals, Birds, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "109-blackbird.tif",
      "src": "image/109-blackbird_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Blackbird (blackened mass)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "110-lion.tif",
      "src": "image/110-lion_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lion (acid)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "111-moonlunar.tif",
      "src": "image/111-moonlunar_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Moon/Lunar")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "112-competition.tif",
      "src": "image/112-competition_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Ouroboros (completion)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }), _vm._v(" "), _c('p', {
    staticClass: "Bhead"
  }, [_vm._v("Animals, Birds, etc. "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(continued)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "113-stag.tif",
      "src": "image/113-stag_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Stag (soul)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "114-sunsol.tif",
      "src": "image/114-sunsol_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Sun/Sol")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "115-unicorn.tif",
      "src": "image/115-unicorn_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Unicorn (spirit)")])]), _vm._v(" "), _c('div', {
    staticClass: "x2x"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "116-birds.tif",
      "src": "image/116-birds_fmt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Birds (volatilization)")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#x-contents-"
    }
  }, [_vm._v("[contents]")])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "footnote-anchor",
    attrs: {
      "href": "#/#footnote-237-1-backlink",
      "id": "footnote-237-1"
    }
  }, [_vm._v("1")]), _vm._v(". "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Tractatus aureus")]), _vm._v(" (1610). The "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Tractatus aureus ")]), _vm._v("is an alchemical treatise in seven chapters attributed to Hermes Trismegistus.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f41059","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SSO.vue
// module id = 78
// module chunks = 0